import { Trash2 } from 'lucide-react';
import { useDungeonEditorStore } from '@/store/dungeonEditorStore';

export function EntityPanel() {
  const selectedEntityId = useDungeonEditorStore((s) => s.selectedEntityId);
  const mapData = useDungeonEditorStore((s) => s.mapData);
  const updateEntity = useDungeonEditorStore((s) => s.updateEntity);
  const removeEntity = useDungeonEditorStore((s) => s.removeEntity);

  const entity = mapData.entities.find((e) => e.id === selectedEntityId);

  if (!entity) return null;

  const labelClass = 'block text-xs text-gray-500 uppercase tracking-wide mb-1';
  const inputClass = 'w-full px-2 py-1.5 bg-gray-950 border border-gray-700 rounded text-sm text-gray-100';

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h2 className="text-sm font-semibold text-gray-200">Entity</h2>
        <button
          onClick={() => removeEntity(entity.id)}
          className="p-1 text-gray-500 hover:text-red-400 hover:bg-red-900/20 rounded transition-colors"
          title="Delete entity"
        >
          <Trash2 size={14} />
        </button>
      </div>

      <div>
        <label className={labelClass}>Name</label>
        <input
          type="text"
          className={inputClass}
          value={entity.name}
          onChange={(e) => updateEntity(entity.id, { name: e.target.value })}
        />
      </div>

      <div className="grid grid-cols-3 gap-2">
        <div className="col-span-2">
          <label className={labelClass}>Type</label>
          <select
            className={inputClass}
            value={entity.type}
            onChange={(e) =>
              updateEntity(entity.id, { type: e.target.value as 'monster' | 'npc' | 'object' })
            }
          >
            <option value="monster">Monster</option>
            <option value="npc">NPC</option>
            <option value="object">Object</option>
          </select>
        </div>
        <div>
          <label className={labelClass}>Icon</label>
          <input
            type="text"
            className={inputClass}
            value={entity.icon}
            onChange={(e) => updateEntity(entity.id, { icon: e.target.value })}
            maxLength={2}
          />
        </div>
      </div>

      {entity.catalogEntryId && (
        <div className="px-2 py-2 bg-gray-800/60 border border-gray-700 rounded text-xs text-gray-400">
          <span className="text-gray-500 uppercase tracking-wide">Catalog ref:</span>{' '}
          <span className="text-gray-300 font-mono">{entity.catalogEntryId}</span>
        </div>
      )}

      <div>
        <label className={labelClass}>Position</label>
        <div className="text-xs text-gray-400 bg-gray-950 border border-gray-700 rounded px-2 py-1.5">
          ({entity.x}, {entity.y})
        </div>
      </div>
    </div>
  );
}
